import { render } from "./GetStartedView.vue?vue&type=template&id=5e9ddb63&scoped=true&ts=true"
import script from "./GetStartedView.vue?vue&type=script&lang=ts"
export * from "./GetStartedView.vue?vue&type=script&lang=ts"

import "./GetStartedView.vue?vue&type=style&index=0&id=5e9ddb63&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9ddb63"]])

export default __exports__